import styled from 'styled-components';
import { SCREEN_SIZE } from './../index';
import { Gray } from '../../colors';
export const HeaderContainer = styled.div `
  padding: 0 10px; 
  display: flex; 
  justify-content: ${props => props.progress ? 'space-between' : 'flex-end'}; 
  width: 100%;
  align-items: center;

  @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
    display: none;
  }
`;
export const HeaderContainerMobile = styled.div `
  display: none;
  flex-direction: column;
  width: 100%; 

  @media (max-width: ${SCREEN_SIZE.MOBILE.max}) {
    display: flex;

    img {
      width: 85px;
    }
  }
`;
export const MainContent = styled.div `
  display: flex;
  justify-content: space-between; 
  align-items: center;
`;
export const Line = styled.div `
  width: 1px;
  height: 30px;
  background-color: ${Gray.light};
  margin-right: auto;
  margin-left: 20px;
`;
export const ChildrenContainer = styled.div `
  display: flex;
  margin-right: auto;
  margin-left: 20px;
`;
//# sourceMappingURL=Header.Styled.js.map